import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import FooterNMV from './footer_N_M_V';
import { NavLink } from 'react-router-dom';

export default function App() {
    return (
        <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
            <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
                <div className='me-5 d-none d-lg-block'>
                    <span>Para mas informacion Contactanos:</span>
                </div>
                <div>
                    <a href='https://www.youtube.com/channel/UCAUZCXTVoFJ4S2x5MlnI5YQ' className='me-4 text-reset' >
                        <MDBIcon fab icon="youtube" size='lg' style={{ color: 'red' }}/>
                    </a>
                    <a href='https://www.facebook.com/people/donuts-paradise/61555212065340/' className='me-4 text-reset'>
                        <MDBIcon color='primary' fab icon='facebook-f' size='lg' />
                    </a>
                    <a href='https://api.whatsapp.com/send/?phone=573147646339&text=Hola%2C+quiero+saber+m%C3%A1s+sobre+sus+donitas+%EF%BF%BD&type=phone_number&app_absent=0' className='me-4 text-reset'>
                        <MDBIcon fab icon="whatsapp-square" size='lg' color='success'/>
                    </a>
                    <a href='https://www.instagram.com/donuts_paradisel/' className='me-4 text-reset'>
                        <MDBIcon fab icon='instagram' size='lg' color='lght'/>
                    </a>
                </div>
            </section>

            <section >
                <MDBContainer fluid className='text-center text-md-start mt-5'>
                    <MDBRow className='mt-3'>
                        <MDBCol md='4' lg='4' xl='3' className='mx-auto mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>
                                <MDBIcon fab icon='youtube' className='me-3' size='lg' style={{ color: 'red' }} />
                                <a className='text-reset fw-bold' href='https://www.youtube.com/channel/UCAUZCXTVoFJ4S2x5MlnI5YQ'>
                                    donuts paradise
                                </a>
                            </h6>

                            <div className='ratio ratio-16x9' >
                                <iframe
                                    src="https://www.youtube.com/embed/A4n2tB1CQ3E?si=LyRX1DA6vcFTz-7u"
                                    title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen>

                                </iframe>
                            </div>
                        </MDBCol>

                        <MDBCol md='6' lg='6' xl='7'>
                            <FooterNMV />
                        </MDBCol>

                        <MDBCol md='2' lg='2' xl='2' className='mx-auto mb-md-0 mb-4'>
                            <h6 className='text-uppercase fw-bold mb-4'>Contactanos</h6>

                            <a className="fw-normal" style={{ color: 'gray', fontWeight: 'bold' }} href='https://maps.app.goo.gl/knbcutD7CGFLNi5g6'>
                                <MDBIcon color='secondary' icon='home' className='me-2' />
                                Cartagena - barrio 20 de julio, sector villa ortega CL 3 E#56 I-13</a>

                            <a className="fw-normal" style={{ color: 'gray', fontWeight: 'bold' }} >
                                <br />
                                <MDBIcon color='secondary' icon='envelope' className='me-3' />
                                Donutsparadise24@gmail.com
                            </a>
                            <br />
                            <a className="fw-normal mt-5" style={{ color: 'gray', fontWeight: 'bold' }} href='https://api.whatsapp.com/send/?phone=573147646339&text=Hola%2C+quiero+saber+m%C3%A1s+sobre+sus+donitas+%EF%BF%BD&type=phone_number&app_absent=0'>
                                <MDBIcon color='secondary' icon='phone' className='me-3' /> +57 314 7646339
                            </a>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>

            <MDBContainer fluid className='mr-auto text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                <MDBRow >
                    <MDBCol md={2}>
                        <NavLink to="/PoliticaPrivacidad" className={"nav-link active"}>
                            Politica de Privacidad
                        </NavLink>

                    </MDBCol>
                    <MDBCol md={2}>
                        <NavLink to="/Terminos" className={"nav-link active"}>
                            Términos y Condiciones
                        </NavLink>
                    </MDBCol>
                    <MDBCol md={4} lg={6} xl={6} >
                        <span>

                        </span>
                    </MDBCol>
                    <MDBCol md={4} lg={2}>
                        <span>
                            © : donuts paradise's 2024
                        </span>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBFooter>
    );
}